import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "../Components/ScrollToTop";

import PageLayout from "../Layouts/PageLayout";
import AuthenticationPage from "../Auth/Authentication";
import HomePage from "../Pages/Home";
import RecommendedMoviesPage from "../Pages/Movies/Recommended";
import UpcomingMoviesPage from "../Pages/Movies/Upcoming";
import TheaterListPage from "../Pages/Theaters/Theaters";
import TheaterInfoPage from "../Pages/Theaters/TheaterInfo";
import ContactUsPage from "../Pages/Contact";
import TermsConditionsPage from "../Pages/TermsConditions";
import PrivacyPolicyPage from "../Pages/PrivacyPolicy";
import RefundPolicyPage from "../Pages/RefundPolicy";
import ProfilePage from "../Pages/Account/Profile";
import BookingListPage from "../Pages/Bookings/BookingList";
import MovieDetailsPage from "../Pages/Movies/Details";
import MovieInfoPage from "../Pages/Movies/MovieInfo";
import ComingSoonMoviesPage from "../Pages/Movies/ComingSoon";
import SeatLayoutScreen from "../Pages/Bookings/SeatLayout";
import BookingSuccessPage from "../Pages/Bookings/BookingSuccess";
import BookingFailPage from "../Pages/Bookings/BookingFail";

const Routers = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="auth" element={<AuthenticationPage />} />
                <Route path="/" element={<PageLayout />}>
                    <Route path="" element={<Navigate to="home" />} />
                    <Route path="home" element={<HomePage />} />
                    <Route path="recommended-movies" element={<RecommendedMoviesPage />} />
                    <Route path="upcoming-movies" element={<UpcomingMoviesPage />} />
                    <Route path="coming-soon-movies" element={<ComingSoonMoviesPage />} />
                    <Route path="movie-details" element={<MovieDetailsPage />} />
                    <Route path="movie-info" element={<MovieInfoPage />} />
                    <Route path="theaters" element={<TheaterListPage />} />
                    <Route path="theater-info" element={<TheaterInfoPage />} />
                    <Route path="contact-us" element={<ContactUsPage />} />
                    <Route path="terms-and-conditions" element={<TermsConditionsPage />} />
                    <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="refund-policy" element={<RefundPolicyPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="bookings" element={<BookingListPage />} />
                    <Route path="seat-layout" element={<SeatLayoutScreen />} />
                    <Route path="booking-success" element={<BookingSuccessPage />} />
                    <Route path="booking-fail" element={<BookingFailPage />} />
                </Route>
            </Routes>
        </>
    );
}

export default Routers;